import { render, staticRenderFns } from "./RelatedTopics.vue?vue&type=template&id=ad1ce4ac&scoped=true&"
import script from "./RelatedTopics.vue?vue&type=script&lang=js&"
export * from "./RelatedTopics.vue?vue&type=script&lang=js&"
import style0 from "./RelatedTopics.vue?vue&type=style&index=0&id=ad1ce4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1ce4ac",
  null
  
)

export default component.exports